// 注册微应用主应用
import { registerMicroApps, start, addGlobalUncaughtErrorHandler, initGlobalState, runAfterFirstMounted, MicroAppStateActions } from 'qiankun';
import apps from "./apps";



registerMicroApps(apps, {
    beforeLoad: (app) => {
		console.log('[LifeCycle] before load %c%s', 'color: green;', app.name);
        return Promise.resolve();
    },
	beforeMount: (app) => {
		console.log("beforeMount");
		return Promise.resolve();
	},
    afterMount: (app) => {
        console.log("after mount", app.name);
        return Promise.resolve();
    },
	afterUnmount: (app) => {
		console.log("afterUnmount");
		return Promise.resolve();
	},
});

runAfterFirstMounted(() => console.log('开启监控:'));

addGlobalUncaughtErrorHandler((event: any) => {
    console.error(event);
    const { message: msg } = event
    if (msg && msg.includes("died in status LOADING_SOURCE_CODE")) {
        console.error("微应用加载失败，请检查应用是否可运行");
    }
});

export default start;